import { FC, useState } from 'react';
import { useAdminBrands } from 'store/admin-brands';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
>;

export const AdminBrandsFilter: FC<Props> = (props) => {
  const [search, setSearch] = useState('');

  const { data: brands, isLoading } = useAdminBrands({ search });

  return (
    <SelectFilter
      {...props}
      options={brands?.items.map((brand) => ({
        key: brand.id,
        label: brand.name,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      multiple
      asyncSearch
    />
  );
};
